import { useCallback, useEffect, useState } from "react";
import { api, extractError } from "../lib/api";
import { useBootstrapWS } from "./useBootstrapWS";
import { toast } from "sonner";

/** Foreman team dashboard and operator management. */
export function useForemanTeam() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const reload = useCallback(async () => {
    try {
      const res = await api.get("/production/foreman/team");
      setData(res.data);
    } catch (err) {
      toast.error(extractError(err));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  useBootstrapWS(["production_foreman", "boiler_logging", "production_monitoring"], reload);

  const run = async (fn, successMsg) => {
    setSubmitting(true);
    try {
      await fn();
      if (successMsg) toast.success(successMsg);
      await reload();
      return true;
    } catch (err) {
      toast.error(extractError(err));
      return false;
    } finally {
      setSubmitting(false);
    }
  };

  const createOperator = (payload) =>
    run(() => api.post("/production/foreman/operators", payload), "Operator created");

  const updateOperator = (id, payload) =>
    run(() => api.patch(`/production/foreman/operators/${id}`, payload), "Operator updated");

  return {
    data,
    loading,
    submitting,
    reload,
    createOperator,
    updateOperator,
    department: data?.department,
    label: data?.label,
    operators: data?.operators || [],
    boiler: data?.boiler,
    runtime: data?.runtime,
    departmentPagePath: data?.department_page_path || "/production",
  };
}
